import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfEquipmentWos
export const getBillOfEquipmentWos = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-equipment-wos`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-equipment-wos:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET a single billOfEquipmentWo
export const getBillOfEquipmentWoById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-equipment-wos/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-equipment-wos:",
      error.response?.data || error,
    );
    throw error;
  }
};

// CREATE a new billOfEquipmentWo
export const createBillOfEquipmentWo = async (billOfEquipmentWoData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/bill-of-equipment-wos`,
      billOfEquipmentWoData,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating bill-of-equipment-wos:",
      error.response?.data || error,
    );
    throw error;
  }
};

// UPDATE an existing billOfEquipmentWo
export const updateBillOfEquipmentWo = async (id, billOfEquipmentWoData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/bill-of-equipment-wos/${id}`,
      billOfEquipmentWoData,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating bill-of-equipment-wos:",
      error.response?.data || error,
    );
    throw error;
  }
};

// DELETE a billOfEquipmentWo
export const deleteBillOfEquipmentWo = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/bill-of-equipment-wos/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting billOfEquipmentWo:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET billOfEquipmentWos by workOrderId
export const getBillOfEquipmentWosByWorkOrderId = async (workOrderId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-equipment-wos`,
      { params: { workOrderId } },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-equipment-wos by WO:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET billOfEquipmentWos by many workOrderIds
export const getBillOfEquipmentWosByWorkOrderIds = async (
  workOrderIds = [],
) => {
  if (!workOrderIds.length) {
    return [];
  }

  try {
    const response = await axiosInstance.get(
      `${API_URL}/bill-of-equipment-wos/by-work-order-ids`,
      {
        params: { workOrderIds: workOrderIds.join(",") },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching bill-of-equipment-wos by WO IDs:",
      error.response?.data || error,
    );
    throw error;
  }
};
